module.exports = __webpack_public_path__ + "static/media/10KM.a6bef3ed.webp";